import React, { useEffect } from "react";
import { Fancybox } from "@fancyapps/ui";
import Pagination from "../Pagination/Pagination";
import EmbeddedVideoResult from "./EmbeddedVideo/EmbeddedVideoResult";

const MediaResults = (props) => {
    useEffect(() => {
        Fancybox.bind('[data-fancybox="media-results-gallery"]');
    }, [props.media]);

    let consentGiven = (CookieInformation.getConsentGivenFor("cookie_cat_statistic") && CookieInformation.getConsentGivenFor("cookie_cat_marketing")) ? true : false;

    return (
        <div
            className={"tab-pane fade show " + (props.initialTab === "media" ? "active" : "")}
            id="pills-media"
            role="tabpanel"
            aria-labelledby="pills-media-tab"
        >
            {props.media?.length > 0 ? (
               
                <>
                    {/* Pagination */}
                    <Pagination
                        handlePageChange={props.handleChange}
                        currentPage={props.mediaPage}
                        pagination={props.pagination}
                    />

                    {/* Results */}
                    <ul className="c-quick-search__result video-result">
                        {props.media.map((item, i) => {
                            if (item.embedCode && item.embedCode !== "") {
                                return <EmbeddedVideoResult item={item} key={i} />;
                            } else {
                                return (
                                    <a href={item.url} target={consentGiven ? null : '_blank'} rel={consentGiven ? null : 'noopener noreferrer'} data-fancybox={consentGiven ? 'media-results-gallery' : null} data-caption={consentGiven ? item.title : null}>
                                        <div className="poster">
                                            <img src={item.posterUrl + "?width=350"} alt={item.description} className="img-fluid" />
                                        </div>
                                        {item.title && <p>{item.title}</p>}
                                    </a>
                                );
                            }
                        })}
                    </ul>
                </>
            ) : (
                <div class="no-results-container">{i18n.getString("quicksearch.nomatchingresults")}</div>
            )}
        </div>
    );
};

export default React.memo(MediaResults);
